import { createRoutine } from 'redux-saga-routines';
import extendRoutine from 'utils/routines';

import {
  CREATE_USER,
  DELETE_USER,
  ASSIGN_USER_ROLES_TO_APPLICATION,
  GET_USER_ROLES_BY_APPLICATION,
  REMOVE_USER_FROM_APPLICATION,
  GET_USER_ROLE,
  EDIT_USER_ROLE,
} from './constants';

// v2 actions
export const createUser = extendRoutine(createRoutine(CREATE_USER), 'RESET');
export const deleteUser = extendRoutine(createRoutine(DELETE_USER), 'RESET');
export const assignUserRolesToApplication = extendRoutine(createRoutine(ASSIGN_USER_ROLES_TO_APPLICATION), 'RESET');
export const getUserRolesByApplication = extendRoutine(createRoutine(GET_USER_ROLES_BY_APPLICATION), 'RESET');
export const removeUserFromApplication = extendRoutine(createRoutine(REMOVE_USER_FROM_APPLICATION), 'RESET');

// Legacy v1 actions (deprecated)
export const getUserRole = extendRoutine(createRoutine(GET_USER_ROLE), 'RESET');
export const editUserRole = extendRoutine(createRoutine(EDIT_USER_ROLE), 'RESET');
